import { useState } from 'react';

const Login = ({ apiFetcher, onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    const userData = { username, password };
    const response = await apiFetcher.sendUserData(userData);
    if (response) {
      onLoginSuccess();
    }
  };

  return (
    <div id="login-container" style={{ display: 'flex' }}>
      <h3>Zaloguj się</h3>
      <input
        id="username"
        placeholder="Nazwa użytkownika"
        type="text"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && handleLogin}
      />
      <input
        id="password"
        placeholder="Hasło"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && handleLogin}
      />
      <button id="login-btn" onClick={handleLogin}>
        <h3>Dalej →</h3>
      </button>
    </div>
  );
};

export default Login;